import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Lifejacket = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.5 15.6C26.575 15.063 26 14.063 26 13V5C26 4.45 25.55 4 25 4H21C20.45 4 20 4.45 20 5C20 7.763 18.2 10 16 10C13.8 10 12 7.763 12 5C12 4.45 11.55 4 11 4H7C6.45 4 6 4.45 6 5V13C6 14.063 5.425 15.063 4.5 15.6C4.187 15.775 4 16.113 4 16.462V27C4 27.55 4.45 28 5 28H27C27.55 28 28 27.55 28 27V16.462C28 16.112 27.812 15.774 27.5 15.599V15.6ZM21.938 6H24.001V13C24.001 14.575 24.751 16.063 26.001 17V20H20.001V19C20.001 18.45 19.551 18 19.001 18H17.001V11.9C19.551 11.4 21.576 9 21.939 6H21.938ZM14 22V20H18V22H14ZM8 13V6H10.063C10.438 9 12.45 11.4 15.001 11.9V18H13.001C12.451 18 12.001 18.45 12.001 19V20H6.001V17C7.251 16.062 8.001 14.575 8.001 13H8ZM6 22H12V23C12 23.55 12.45 24 13 24H15V26H6V22ZM17 26V24H19C19.55 24 20 23.55 20 23V22H26V26H17Z" />
	</svg>
);

export default Lifejacket;
